import { FC } from "react";
import lodash from "lodash";
import {ClipboardDocumentListIcon} from "@heroicons/react/24/outline";
import {StatusBadge} from "../../core";

const fileNameMap = {
  approvedTechnicalDocument: "Approved Technical Document",
  calibrationCertificate: "Calibration Certificate",
  typeTestReport: "Type Test Report",
  ISO14001: "ISO 14001: Environmental Management System Standard",
  ISO45001: "ISO 45001: Occupational Health and Safety Management System",
  ISO9001: "ISO 9001",
  schematicWiringDrawing: "Schematic Wiring Drawing",
  installationOperationalAndMaintenanceManuals: "Installation, Operation and Maintenance Manuals",
  detailedPartListAndMaterialsOfConstruction: "Detailed Parts List and Materials of Construction",
}

const DocumentationInfoSummary: FC<{  meterContractor: any }> = ({ meterContractor }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>

      <div className=" overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 bg-white">
          <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="pl-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >

            </th>
            <th
              scope="col"
              className="pl-3 pr-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Document Name
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Status
            </th>
          </tr>
          </thead>

          {/* Table Body */}
          <tbody className="divide-y divide-gray-200">
          {Object.keys(fileNameMap)
            .map((fileKey) => {

              const doc = lodash.get(meterContractor?.documentation, fileKey);
              let uploadStatus = !!doc?.url ? "Complete" : "Incomplete"

              return (
                <tr key={fileKey} className="hover:bg-gray-50 transition-colors">
                  <td className="pl-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900 overflow-ellipsis ">
                    <ClipboardDocumentListIcon className={'text-gray-600 w-4'} />
                  </td>
                  <td className="pl-3 pr-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 overflow-ellipsis ">
                    <p className={"max-w-[250px] overflow-hidden text-ellipsis"}>
                      {fileNameMap[fileKey as keyof typeof fileNameMap]}
                    </p>
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    <StatusBadge
                      status={uploadStatus}
                      options={{
                        "Complete": "bg-green-100 text-green-600",
                        "Incomplete": "bg-red-100 text-red-600",
                      }}
                    />
                  </td>
                </tr>
              )})}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default DocumentationInfoSummary;